import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {displayDateFromDate, diamondImgUrl, diamondTitle, diamondPrice, diamondCartDesc} from '../../../../utils/formatting';


import * as cartActionCreators from '../../../../actions/cart';
import * as productActionCreators from '../../../../actions/product';
let allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);

class ProductDiamondBanner extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
      nextStepsOpen: false,
      inCart: false,

      hkOOS: false,
    };
	}

	componentDidMount() {
    if(this.props.productData.vendor == 'HK') {
      this.props.productHkDiamondAvailability(this.props.productData.stockNo)
      .then((resp) => {
        try {
          const respJson = JSON.parse(decodeURI(resp));
          if(respJson.Data && respJson.Data[0]) {
            if(respJson.Data[0]['Status'] === "NotAvailable") {
              this.setState({
                hkOOS: true,
              });
            }
          }
        } catch(err) {
          console.error(err);
        }
      })
      .catch((errResp) => {
        console.error(errResp);
      });
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  toggleNextSteps() {
    this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
  }

  openIntercom() {
    acquireIO.max();
  }

  getShippingDate() {

    let DIAMOND_LEAD_DAYS = 46;
    let today = new Date();

    today.setDate(today.getDate() + DIAMOND_LEAD_DAYS);
    return today;
  }

  addToCart() {
    
    this.setState({ inCart: true });

    let shapeString = this.props.productData.shape;

    this.props.cartAddDiamond(this.props.productData.stockNo, this.props.productData.price, shapeString.toLowerCase().trim(), diamondCartDesc(this.props.productData))
    .then((resp) => {
      console.log(resp);
      this.externalNav('checkout/cart');
    })
    .catch((resp) => {
      this.setState({ inCart: false });
    });
  }

  addSetting() {
    this.props.productSelectDiamond(this.props.productData);
    this.internalNav('gallery/engagement-rings?view=results&tabtype=setting');
  }

  backToResults() {
    let pageNum = this.props.product.currentPage ? this.props.product.currentPage : 1;
      this.internalNav('gallery/engagement-rings?view=results&currentPage=' + pageNum + '&tabtype=diamond');
  }

  isOutOfStock() {
    if(this.props.productData && this.props.productData.status && this.props.productData.status === 3) {
      return true;
    }
    if(this.state.hkOOS) {
      return true;
    }
    return false;
  }

  getSimilarLink() {

    const caratMin = parseFloat(this.props.productData.caratWeight).toFixed(2).toString();
    const caratMax = (1.1 * parseFloat(this.props.productData.caratWeight)).toFixed(2).toString();
    const color = this.props.productData.color.toUpperCase();
    const clarity = this.props.productData.clarity;
    const shape = this.props.productData.shape.toLowerCase();

    return `gallery/engagement-rings?mode=diamond&caratMin=${caratMin}&caratMax=${caratMax}&color=${color}&clarityMin=${clarity}&clarityMax=${clarity}&shape=${shape}`;
  }

	render() {

    if(!this.props.productData) {
      return null;
    }

		return <div className='ProductDiamondBanner'>
			<div className='imageSection'>
        <div className='primaryImageWrapper'>
          <img src={this.props.productData.image} />
        </div>
        <div className='thumbnailsWrapper'>
          <div className='thumbWrapper' style={{display: 'none'}}>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/dview_thumb1.jpg' />
          </div>
          <div className='thumbWrapper'>
            <img src={this.props.productData.image} />
          </div>
          <div className='thumbWrapper' style={{display: 'none'}}>
            <img src='https://ddw2.diamondsdirect.com/img/productpage/dview_thumb3.jpg' />
          </div>
        </div>
      </div>
      <div className='descriptionSection'>
        <div className='diamondTitle'>{diamondTitle(this.props.productData)}</div>
        <div className='priceWrapper'>
          <div className='priceSign'>$</div>
          <div className='priceValue'>{this.isOutOfStock() ? '-' : this.props.productData.price.toLocaleString()}</div>
        </div>
        <div className='priceNotice'>(diamond&nbsp;&nbsp;only)</div>
        {this.isOutOfStock() ?
          <div className='oosNotice'>This diamond is no longer available. <span className='oosLink' onClick={() => this.internalNav(this.getSimilarLink())}>Find something similar?</span></div> :
          null
        }
        {this.state.inCart ?
          <div className='nextStepsInCart'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
          <div className='nextStepsWrapper'>
            <div className='nextStepsElement' onClick={::this.toggleNextSteps}>
              <div className='nextStepsHead'>
                <div className='nextStepsLabel'>Next Steps</div>
                <div className='nextStepsIcon'>
                  <img src='https://ddw2.diamondsdirect.com/img/productpage/down.svg' />
                </div>
              </div>
              <div className={this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody'}>
                <div className='nextStepsBodyWrapper'>
                  {!this.isOutOfStock() ?
                    <div className='nextStepsItem' onClick={() => this.addToCart()}>Add to Cart</div> :
                    null
                  }
                  {!this.isOutOfStock() ?
                    <div className='nextStepsItem' onClick={() => this.addSetting()}>Add to Ring</div> :
                    null 
                  }
                  <div className='nextStepsItem' onClick={() => this.backToResults()}>Back to Results</div>
                  <div className='nextStepsItem' onClick={() => this.internalNav('contact-us')}>Request an Appointment</div>
                </div>
              </div>
            </div>
          </div>
        }
        <div className='shippingInfoWrapper'>
          <div className='shippingDateLine' style={{display: 'none'}}>Estimated Shipping Date: {displayDateFromDate(this.getShippingDate())}</div>
          <div className='shippingContactLine' style={{display: 'none'}}>Need it sooner?&nbsp;<span className='clickableText' onClick={::this.openIntercom}>Speak to an Expert</span></div>
          <div className='shippingFreeLine'>Free shipping and free lifetime jewelry care with every purchase -&nbsp;<span className='clickableText' onClick={() => this.props.scrollMethod()}>Learn More</span></div>
        </div>
        <div className='actionsWrapper'>
          <div className='actionItem' style={{display: 'none'}}>
            <div className={'actionIcon hint'}>
              <img src='https://ddw2.diamondsdirect.com/img/productpage/hint.svg' />
            </div>
            <div className='actionLabel'>Drop a Hint</div>
          </div>
          <div className='actionItem' onClick={() => this.internalNav('contact-us')}>
            <div className='actionIcon'>
              <img src='https://ddw2.diamondsdirect.com/img/productpage/consult.svg' />
            </div>
            <div className='actionLabel'>Consult an Expert</div>
          </div>
          <div className='actionItem' style={{display: 'none'}}>
            <div className='actionIcon'>
              <img src='https://ddw2.diamondsdirect.com/img/productpage/wishlist.svg' />
            </div>
            <div className='actionLabel'>Add to Wishlist</div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default ProductDiamondBanner;

function mapStateToProps(state) {
  return {
    product: state.product,
    user: state.user,
  };
}

export const ProductDiamondBannerContainer = connect(
  mapStateToProps,
  allActionCreators
)(ProductDiamondBanner);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductDiamondBanner.jsx